import { PHONE_REGIONS, resolveRegion } from '~/config/localNumbers'

/**
 * Push the initial route's display number to the dataLayer before GTM
 * evaluates (gtm.js injection is deferred ~7s in gtm.client.ts; queued pushes
 * replay FIFO when the container loads). The GTM `DLV - Local Phone` variable
 * feeds the Calls-from-Website tag's "Displayed Phone Number to Replace"
 * field, so the value must be the exact display string the page renders.
 *
 * Initial route only, by design: the tag fires once per container load, so a
 * re-push on SPA navigation would have no consumer (see the plan's coverage
 * notes on client-side navigation).
 */
export default defineNuxtPlugin(() => {
  const route = useRoute()
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ local_phone: PHONE_REGIONS[resolveRegion(route.path)].display })
})
